const EmailNotSent = () => {
  return `
    <div>
      <span class="text-red-500 text-xl font-bold">Email Was Not Sent.</span>
      <br />
      <span>
        Unfortunately, you can not send an email right now. Please try again
        later. In the meantime, feel free to message me on LinkedIn!
      </span>
    </div>`;
};

export default EmailNotSent;
